import ApplicantNavigator from './ApplicantNavigator';

export default ApplicantNavigator;
